// Partner preferences -> the filters the Browse page and the matches list understand.
// Blank, "Any" and "Doesn't Matter" mean "no restriction", so they are left out.
const open = (v) => {
    const t = String(v ?? '').trim();
    return t && !/^(any( .*)?|doesn'?t matter|no preference)$/i.test(t) ? t : '';
};

export const hasSavedPreferences = (profile) => Boolean(profile?.prefCompleted);

export const prefsToFilters = (profile) => {
    if (!profile?.prefCompleted) return {};
    const filters = {
        religion: open(profile.prefReligion),
        caste: open(profile.prefCaste),
        subCaste: open(profile.prefSubCaste),
        maritalStatus: open(profile.prefMaritalStatus),
        state: open(profile.prefState),
        city: open(profile.prefCity),
        rasi: open(profile.prefRasi),
        nakshatra: open(profile.prefNakshatra),
        dosham: open(profile.prefDosham),
        minAge: open(profile.prefAgeMin),
        maxAge: open(profile.prefAgeMax),
    };
    return Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
};

const ageOf = (dateOfBirth) => {
    const birth = new Date(dateOfBirth);
    if (Number.isNaN(birth.getTime())) return null;
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const beforeBirthday = today.getMonth() < birth.getMonth()
        || (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate());
    if (beforeBirthday) age -= 1;
    return age > 0 ? age : null;
};

// When a member has not saved partner preferences yet, use their own profile
// as a sensible starting point. Age direction follows the opposite-gender
// matching flow: women see same-age/older men; men see same-age/younger women.
export const profileToFallbackFilters = (profile) => {
    if (!profile) return {};
    const age = ageOf(profile.dateOfBirth);
    const filters = {
        religion: open(profile.religion),
        city: open(profile.city),
        caste: open(profile.caste),
        subCaste: open(profile.subCaste),
        maritalStatus: open(profile.maritalStatus),
    };
    if (age && profile.gender === 'Female') filters.minAge = String(age);
    if (age && profile.gender === 'Male') filters.maxAge = String(age);
    return Object.fromEntries(Object.entries(filters).filter(([, value]) => value));
};
